import dynamic from 'next/dynamic';

function TrainerApplyMultiStepLoading() {
  return (
    <div className="flex flex-col w-full border-t border-b animate-pulse">
      <div className="w-full py-10">
        <div className="flex items-center justify-center w-full space-x-2 md:space-x-0">
          <div className="flex items-center">
            <div className="w-8 h-8 md:w-10 md:h-10 rounded-full bg-gray-200" />
            <div className="hidden md:block w-10 h-0.5 bg-gray-200" />
          </div>
          <div className="flex items-center">
            <div className="w-8 h-8 md:w-10 md:h-10 rounded-full bg-gray-200" />
            <div className="hidden md:block w-10 h-0.5 bg-gray-200" />
          </div>
          <div className="flex items-center">
            <div className="w-8 h-8 md:w-10 md:h-10 rounded-full bg-gray-200" />
            <div className="hidden md:block w-10 h-0.5 bg-gray-200" />
          </div>
          <div className="flex items-center">
            <div className="w-8 h-8 md:w-10 md:h-10 rounded-full bg-gray-200" />
            <div className="hidden md:block w-10 h-0.5 bg-gray-200" />
          </div>
          <div className="flex items-center">
            <div className="w-8 h-8 md:w-10 md:h-10 rounded-full bg-gray-200" />
            <div className="hidden md:block w-10 h-0.5 bg-gray-200" />
          </div>
          <div className="flex items-center">
            <div className="w-8 h-8 md:w-10 md:h-10 rounded-full bg-gray-200" />
          </div>
        </div>
      </div>
      <div className="bg-gray-100 py-10 lg:py-14">
        <div className="container max-w-screen-md mx-auto px-10">
          <div className="flex flex-col space-y-10">
            <div className="w-full space-y-4 flex flex-col items-center">
              <div className="w-full h-8 bg-gray-200" />
              <div className="w-2/4 h-8 bg-gray-200" />
            </div>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-10">
              <div className="flex flex-col space-y-3">
                <div className="w-2/5 h-4 bg-gray-200" />
                <div className="w-full h-7 bg-gray-200" />
              </div>
              <div className="flex flex-col space-y-3">
                <div className="w-2/5 h-4 bg-gray-200" />
                <div className="w-full h-7 bg-gray-200" />
              </div>
              <div className="flex flex-col space-y-3">
                <div className="w-2/5 h-4 bg-gray-200" />
                <div className="w-full h-7 bg-gray-200" />
              </div>
              <div className="flex flex-col space-y-3">
                <div className="w-2/5 h-4 bg-gray-200" />
                <div className="w-full h-7 bg-gray-200" />
              </div>
              <div className="flex flex-col space-y-3">
                <div className="w-2/5 h-4 bg-gray-200" />
                <div className="w-full h-7 bg-gray-200" />
              </div>
              <div className="flex flex-col space-y-3">
                <div className="w-2/5 h-4 bg-gray-200" />
                <div className="w-full h-7 bg-gray-200" />
              </div>
              <div className="flex flex-col space-y-3">
                <div className="w-2/5 h-4 bg-gray-200" />
                <div className="w-full h-7 bg-gray-200" />
              </div>
              <div className="flex flex-col space-y-3">
                <div className="w-2/5 h-4 bg-gray-200" />
                <div className="w-full h-7 bg-gray-200" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const TrainerApplyMultiStep = dynamic(() => import('./TrainerApplyMultiStep'), {
  ssr: false,
  loading: () => <TrainerApplyMultiStepLoading />,
});

export default function TrainerApplyMultiStepWrapper() {
  return <TrainerApplyMultiStep />;
}
